import { inject, Injectable } from '@angular/core';
import { ToastFacade } from '../state/toasts/toast.facade';
import { ToastType } from './models/toast.model';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly translateService = inject(TranslateService);
  private readonly toastFacade = inject(ToastFacade);

  showToast(label: string, type: ToastType = 'success', params: Record<string, unknown> = {}) {
    this.toastFacade.createToast({ message: this.translateService.instant(label, params), type });
  }

  showToastRaw(message: string, type: ToastType = 'success') {
    this.toastFacade.createToast({ message, type });
  }
}
